import { SVGProps, Ref, forwardRef } from 'react';

export const StarHalfFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 1.333c-1.778 0-2.826 2.517-4.923 7.55l-.467 1.119-1.156.093c-5.434.44-8.151.659-8.7 2.35-.55 1.69 1.52 3.465 5.658 7.015l.837.718-.271 1.14c-1.262 5.304-1.893 7.956-.454 9.001 1.438 1.045 3.765-.374 8.42-3.213l1.021-.623 1.023.623c4.654 2.839 6.981 4.258 8.42 3.213 1.438-1.045.807-3.697-.455-9l-.26-1.092.895-.767c4.138-3.55 6.207-5.324 5.657-7.015s-3.266-1.91-8.7-2.35l-1.155-.093-.467-1.12C18.826 3.85 17.778 1.333 16 1.333m0 22.36 2.237 1.364c2.396 1.461 3.967 2.413 5.117 2.908.484.21.498.199.45-.326-.117-1.247-.536-3.035-1.186-5.765l-.598-2.516 2.005-1.72c2.13-1.827 3.52-3.027 4.347-3.967.348-.397.343-.413-.172-.529-1.22-.274-3.051-.428-5.848-.654l-2.615-.212-1.03-2.47c-1.079-2.591-1.79-4.285-2.43-5.36-.134-.228-.206-.341-.277-.341z"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarHalfFilledSize32Glyph.displayName = 'StarHalfFilledSize32Glyph';
